/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FccDataCenterInstallationStatusEnumDTO } from './fcc-data-center-installation-status-enum-dto';


/**
 * Information about FCC into Data Center
 */
export interface FccDataCenterDTO { 
    /**
     * The date time field when FCC installation into Data Center was triggered.
     */
    installationTriggerDate?: string;
    installationStatus?: FccDataCenterInstallationStatusEnumDTO;
    /**
     * URL of installed FCC
     */
    url?: string;
    /**
     * API Key for connecting to FCC Data Center. It is returned only once (e.g. if the installation is triggered or API Key is regenerated). Store this API key. The API Key is used in a connection url as a path param. The exact format is `{url}/{apiKey}`. If a returned `url` is `https://datacenter.fiskal.cloud/fcc-1234-5678` then its FCC url is: `https://datacenter.fiskal.cloud/fcc-1234-5678/{apiKey}`
     */
    apiKey?: string;
}

export class ClsFccDataCenterDTO { 
    /**
     * The date time field when FCC installation into Data Center was triggered.
     */
    installationTriggerDate?: string = undefined;
    installationStatus?: FccDataCenterInstallationStatusEnumDTO = undefined;
    /**
     * URL of installed FCC
     */
    url?: string = undefined;
    /**
     * API Key for connecting to FCC Data Center. It is returned only once (e.g. if the installation is triggered or API Key is regenerated). Store this API key. The API Key is used in a connection url as a path param. The exact format is `{url}/{apiKey}`. If a returned `url` is `https://datacenter.fiskal.cloud/fcc-1234-5678` then its FCC url is: `https://datacenter.fiskal.cloud/fcc-1234-5678/{apiKey}`
     */
    apiKey?: string = undefined;
}



